<template>
  <!--
    竖屏比例容器: PC/平板 等横屏设备上, 把移动端内容塞进固定竖屏设计盒
    内部 DESIGN_W x DESIGN_H 固定, 整体 transform scale 适配屏幕
    两侧留黑边 (pillarbox)
  -->
  <div class="portrait-frame">
    <div class="portrait-stage" :style="stageStyle">
      <div class="portrait-inner" :style="innerStyle">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'

// 设计基准: 接近 iPhone 14 Pro Max, 比例 ~0.46
const DESIGN_W = 430
const DESIGN_H = 932

const winW = ref(window.innerWidth)
const winH = ref(window.innerHeight)

// 取宽高较小缩放: 等比撑满, 保持 430x932 比例, 两侧自动黑边
const scale = computed(() => {
  const sH = winH.value / DESIGN_H
  const sW = winW.value / DESIGN_W
  return Math.min(sH, sW)
})

const stageStyle = computed(() => ({
  width: `${DESIGN_W * scale.value}px`,
  height: `${DESIGN_H * scale.value}px`,
}))

const innerStyle = computed(() => ({
  width: `${DESIGN_W}px`,
  height: `${DESIGN_H}px`,
  transform: `scale(${scale.value})`,
  transformOrigin: 'top left',
}))

const onResize = () => {
  winW.value = window.innerWidth
  winH.value = window.innerHeight
}
onMounted(() => window.addEventListener('resize', onResize))
onUnmounted(() => window.removeEventListener('resize', onResize))

defineExpose({ scale })
</script>

<style scoped lang="scss">
.portrait-frame {
  position: fixed;
  inset: 0;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.portrait-stage {
  position: relative;
  overflow: hidden;
}

.portrait-inner {
  position: absolute;
  top: 0;
  left: 0;
  background: var(--color-bg);
}
</style>
